/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PoliciesRouteImport } from './routes/_policies'
import { Route as PoliciesIndexRouteImport } from './routes/_policies.index'
import { Route as PoliciesNewPolicyRouteImport } from './routes/_policies.new-policy'
import { Route as PoliciesFindingsRouteImport } from './routes/_policies.findings'
import { Route as PoliciesEditPolicyPolicyIdRouteImport } from './routes/_policies.edit-policy.$policyId'
import { Route as PoliciesAccessMapAssetIdRouteImport } from './routes/_policies.access-map.$assetId'

const PoliciesRoute = PoliciesRouteImport.update({
  id: '/_policies',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliciesIndexRoute = PoliciesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PoliciesRoute,
} as any)
const PoliciesNewPolicyRoute = PoliciesNewPolicyRouteImport.update({
  id: '/new-policy',
  path: '/new-policy',
  getParentRoute: () => PoliciesRoute,
} as any)
const PoliciesFindingsRoute = PoliciesFindingsRouteImport.update({
  id: '/findings',
  path: '/findings',
  getParentRoute: () => PoliciesRoute,
} as any)
const PoliciesEditPolicyPolicyIdRoute =
  PoliciesEditPolicyPolicyIdRouteImport.update({
    id: '/edit-policy/$policyId',
    path: '/edit-policy/$policyId',
    getParentRoute: () => PoliciesRoute,
  } as any)
const PoliciesAccessMapAssetIdRoute =
  PoliciesAccessMapAssetIdRouteImport.update({
    id: '/access-map/$assetId',
    path: '/access-map/$assetId',
    getParentRoute: () => PoliciesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PoliciesIndexRoute
  '/findings': typeof PoliciesFindingsRoute
  '/new-policy': typeof PoliciesNewPolicyRoute
  '/access-map/$assetId': typeof PoliciesAccessMapAssetIdRoute
  '/edit-policy/$policyId': typeof PoliciesEditPolicyPolicyIdRoute
}
export interface FileRoutesByTo {
  '/findings': typeof PoliciesFindingsRoute
  '/new-policy': typeof PoliciesNewPolicyRoute
  '/': typeof PoliciesIndexRoute
  '/access-map/$assetId': typeof PoliciesAccessMapAssetIdRoute
  '/edit-policy/$policyId': typeof PoliciesEditPolicyPolicyIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_policies': typeof PoliciesRouteWithChildren
  '/_policies/findings': typeof PoliciesFindingsRoute
  '/_policies/new-policy': typeof PoliciesNewPolicyRoute
  '/_policies/': typeof PoliciesIndexRoute
  '/_policies/access-map/$assetId': typeof PoliciesAccessMapAssetIdRoute
  '/_policies/edit-policy/$policyId': typeof PoliciesEditPolicyPolicyIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/findings'
    | '/new-policy'
    | '/access-map/$assetId'
    | '/edit-policy/$policyId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/findings'
    | '/new-policy'
    | '/'
    | '/access-map/$assetId'
    | '/edit-policy/$policyId'
  id:
    | '__root__'
    | '/_policies'
    | '/_policies/findings'
    | '/_policies/new-policy'
    | '/_policies/'
    | '/_policies/access-map/$assetId'
    | '/_policies/edit-policy/$policyId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PoliciesRoute: typeof PoliciesRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_policies': {
      id: '/_policies'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PoliciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_policies/': {
      id: '/_policies/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PoliciesIndexRouteImport
      parentRoute: typeof PoliciesRoute
    }
    '/_policies/new-policy': {
      id: '/_policies/new-policy'
      path: '/new-policy'
      fullPath: '/new-policy'
      preLoaderRoute: typeof PoliciesNewPolicyRouteImport
      parentRoute: typeof PoliciesRoute
    }
    '/_policies/findings': {
      id: '/_policies/findings'
      path: '/findings'
      fullPath: '/findings'
      preLoaderRoute: typeof PoliciesFindingsRouteImport
      parentRoute: typeof PoliciesRoute
    }
    '/_policies/edit-policy/$policyId': {
      id: '/_policies/edit-policy/$policyId'
      path: '/edit-policy/$policyId'
      fullPath: '/edit-policy/$policyId'
      preLoaderRoute: typeof PoliciesEditPolicyPolicyIdRouteImport
      parentRoute: typeof PoliciesRoute
    }
    '/_policies/access-map/$assetId': {
      id: '/_policies/access-map/$assetId'
      path: '/access-map/$assetId'
      fullPath: '/access-map/$assetId'
      preLoaderRoute: typeof PoliciesAccessMapAssetIdRouteImport
      parentRoute: typeof PoliciesRoute
    }
  }
}

interface PoliciesRouteChildren {
  PoliciesFindingsRoute: typeof PoliciesFindingsRoute
  PoliciesNewPolicyRoute: typeof PoliciesNewPolicyRoute
  PoliciesIndexRoute: typeof PoliciesIndexRoute
  PoliciesAccessMapAssetIdRoute: typeof PoliciesAccessMapAssetIdRoute
  PoliciesEditPolicyPolicyIdRoute: typeof PoliciesEditPolicyPolicyIdRoute
}

const PoliciesRouteChildren: PoliciesRouteChildren = {
  PoliciesFindingsRoute: PoliciesFindingsRoute,
  PoliciesNewPolicyRoute: PoliciesNewPolicyRoute,
  PoliciesIndexRoute: PoliciesIndexRoute,
  PoliciesAccessMapAssetIdRoute: PoliciesAccessMapAssetIdRoute,
  PoliciesEditPolicyPolicyIdRoute: PoliciesEditPolicyPolicyIdRoute,
}

const PoliciesRouteWithChildren = PoliciesRoute._addFileChildren(
  PoliciesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  PoliciesRoute: PoliciesRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
